import React, {Component} from 'react'
import {Layout, Menu, Icon, Avatar,} from 'antd';
import {Link, withRouter} from 'react-router-dom'

import SiderLogo from '../../assets/images/logo.png'
import userUtils, {getUserInfo} from "../../utills/userUtils";
import authorizeBase from "../authorize/authorizeBase";
const {Sider} = Layout;
const {SubMenu} = Menu;
const AuthMenuItem = authorizeBase(Menu.Item);

class SiderMenu extends Component {
    state = {
        name: ""
    };

    componentWillMount() {
        getUserInfo().then((userInfo) => {
            this.setState({
                name: userInfo.name,
                supplierCode: userInfo.supplierCode,
            })
        })
    }

    render() {

        const path = this.props.location.pathname
        const {supplierCode} = this.state;
        return (
            <Sider trigger={null} collapsible collapsed={false} style={{overflowY: 'auto', background: '#fff'}}>
                <div className='siderLogo'>
                    <a href='http://55train.com'>
                        <img src={SiderLogo} alt="SiderLogo" style={{width: '140px'}}/>
                    </a>
                </div>
                <div className="sliderUser">
                    <div className='sider-user-info'>
                        <Avatar size={20} icon="user" className='siderAvatar'/>
                        <span className='sider-userName' onDoubleClick={() => {
                            userUtils.resetUserInfo()
                        }}>{this.state.name}</span>
                    </div>
                </div>
                <Menu theme="white" mode="inline"
                      selectedKeys={[path]}
                      defaultOpenKeys={['sub1']}>
                    <AuthMenuItem key="1" style={{paddingLeft: '0px'}} authority="page:index">
                        <Link to='/home'>
                            <Icon type="home"/>
                            <span>首页</span>
                        </Link>
                    </AuthMenuItem>
                    <SubMenu key="sub1" title={<span><Icon type="unordered-list"/><span>电商订单</span></span>}>
                        <Menu.Item key="/">
                            <Link to='/'>
                                <span>订单管理</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="/goodsList">
                            <Link to='/goodsList'>
                                <span>货物管理</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="/trackList">
                            <Link to='/trackList'>
                                <span>物流信息维护</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="/deviceListYg">
                            <Link to='/deviceListYg'>
                                <span>GPS设备查询</span>
                            </Link>
                        </Menu.Item>
                        {/* <Menu.Item key="/docList">
                         <Link to='/docList'>
                         <span>单证管理</span>
                         </Link>
                         </Menu.Item>*/}
                    </SubMenu>
                    {supplierCode === 'KuaiTie' ?
                        <SubMenu key="sub2" title={<span><Icon type="unordered-list"/><span>快铁订单</span></span>}>
                            <Menu.Item key="/kt-orders">
                                <Link to='/kt-orders'>
                                    <span>订单管理</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/ktTrackList">
                                <Link to='/ktTrackList'>
                                    <span>物流信息维护</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/deviceList">
                                <Link to='/deviceList'>
                                    <span>GPS设备管理</span>
                                </Link>
                            </Menu.Item>
                        </SubMenu>
                        : null}
                    {supplierCode === 'KuaiTie' ?
                        <SubMenu key="sub5" title={<span><Icon type="unordered-list"/><span>线路图维护</span></span>}>
                            <Menu.Item key="/routes">
                                <Link to='/routes'>
                                    <span>线路图维护</span>
                                </Link>
                            </Menu.Item>
                        </SubMenu> : null}
                    {supplierCode === 'KuaiTie' ?
                        <SubMenu key="sub3" title={<span><Icon type="unordered-list"/><span>企业</span></span>}>
                            <Menu.Item key="/companyList">
                                <Link to='/companyList'>
                                    <span>企业列表</span>
                                </Link>
                            </Menu.Item>
                        </SubMenu> : null}
                    {/*<SubMenu key="sub4" title={<span><Icon type="unordered-list"/><span>系统管理</span></span>}>*/}
                    {/*    <Menu.Item key="/addressList">*/}
                    {/*        <Link to='/addressList'>*/}
                    {/*            <span>地址管理</span>*/}
                    {/*        </Link>*/}
                    {/*    </Menu.Item>*/}
                    {/*</SubMenu>*/}
                </Menu>
            </Sider>
        )
    }
}

export default withRouter(SiderMenu)